import { NavLink, useLocation, matchPath } from 'react-router-dom';
import { config } from '../../config';
import { formatCounter } from '../../utils/formatCounter';
import { useChat } from '../../context/ChatProvider';

const SHOW_NAV_ROUTES = [
  config.ROUTES.MEET,
  config.ROUTES.ROULETTE,
  config.ROUTES.STREAMS.LIST,
  config.ROUTES.CHATS.LIST,
  config.ROUTES.NOTIFICATIONS
];

const navigationConfig = [
  {
    href: config.ROUTES.MEET,
    icon: '/icons/bottom_bar_button_1.svg'
  },
  {
    href: config.ROUTES.ROULETTE,
    icon: '/icons/bottom_bar_button_2.svg'
  },
  {
    href: config.ROUTES.STREAMS.LIST,
    icon: '/icons/bottom_bar_button_3.svg'
  },
  {
    href: config.ROUTES.CHATS.LIST,
    icon: '/icons/bottom_bar_button_4.svg',
    badge: 'chats'
  },
  {
    href: config.ROUTES.PROFILE_MENU,
    icon: '/icons/basil_user-solid.svg'
  },
  {
    href: config.ROUTES.MYTA_IDEA,
    icon: '/icons/myta-coin.svg'
  }
];

export const Navigation = () => {
  const location = useLocation();
  const { totalUnread } = useChat();

  const hideNavigation = !SHOW_NAV_ROUTES.some((route) =>
    matchPath(route, location.pathname)
  );

  if (hideNavigation) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10] flex justify-center px-2">
      <div className="mb-4 w-full max-w-[420px] bg-[#022424] flex items-center justify-between rounded-full px-1">
        {navigationConfig.map((n) => (
          <NavLink
            key={n.href}
            to={n.href}
            className={({ isActive }) =>
              `relative flex-1 min-w-0 aspect-square max-w-[64px] max-h-[64px] rounded-full flex justify-center items-center ${
                isActive ? 'bg-[#FFFFFF1A]' : 'bg-transparent'
              }`
            }
          >
            <img
              src={n.icon}
              className="w-[24px] h-[24px]"
              alt="Иконка"
            />

            {n.badge === 'chats' && totalUnread > 0 && (
              <div className="absolute top-[8%] right-[8%] min-w-[20px] h-[20px] px-[3px] bg-[#A1F69E] text-black text-xs font-bold border-4 border-[#1C3D3D] rounded-full flex items-center justify-center">
                {formatCounter(totalUnread)}
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
